import { Pipe, PipeTransform } from '@angular/core';

import { toDisplayDate } from '../utils/date-utils';

/**
 * Renders a calendar date for the user as `MMM-DD-YYYY` (May-15-1990).
 *
 * Use this instead of Angular's `| date`. The built-in pipe parses a date-only string
 * such as '1990-05-15' as UTC midnight but formats it in the browser's local timezone,
 * so it renders the previous day everywhere west of Greenwich - which is why Canadian
 * and US customers saw a date one day behind the one they picked.
 */
@Pipe({
  name: 'displayDate',
})
export class DisplayDatePipe implements PipeTransform {
  transform(value: any, fallback = ''): string {
    return toDisplayDate(value) || fallback;
  }
}
